import endpoints from "../constants/endpoints";
import { UNAVAILABLE } from "../constants/product";
import { routeCountryPath } from "./common";

/**
 * Handle direct product-page concerns without changing the customer's order
 * context. Opening or refreshing a PDP must not silently change fulfillment.
 * @param component
 * @return void
 */
export const handleProductWithDirectLink = component => {
  const { product } = component.state;
  const { history } = component.props;

  const availability = product?.availability;

  if (availability === UNAVAILABLE) {
    history.push(routeCountryPath(endpoints.homePage));
  }
};

export const sortOptionByPreset = (options, customizeProducts) => {
  return options.map(option => {
    if (customizeProducts[option.id]) {
      const countQuantity = {};
      customizeProducts[option.id].forEach(x => {
        countQuantity[x] = (countQuantity[x] || 0) + 1;
      });
      // eslint-disable-next-line
      option.options = option.options?.map(item => {
        if (countQuantity[item.id]) {
          return { ...item, quantity: countQuantity[item.id] };
        }
        return { ...item, quantity: 0 };
      });

      option.options.sort((a, b) =>
        // eslint-disable-next-line
        a.quantity < b.quantity ? 1 : b.quantity < a.quantity ? -1 : 0
      );
    }
    return option;
  });
};
